import { Button } from 'antd';
import React from 'react';
import { useGlobalState } from '../GlobalState';
import { USER_BOOKING_STEP_ORDER } from '../../index';
import { sendWidgetMessage } from '../../../../utils/widgetUtils';
import PaymentFailure from '../payment_page/PaymentFailure';

function UserBookingFailurePage({ fisheryPublicId }) {
  const [bookingId] = useGlobalState('bookingId');
  const [isInsideWidget] = useGlobalState('isInsideWidget');
  const [, setCurrent] = useGlobalState('current');

  const [finalPricing] = useGlobalState('finalPricing');
  const isFreeBooking = parseFloat(finalPricing) === 0;

  return (
    <PaymentFailure
      headerContent={
        <p>
          <span className={'gSemiBold black'}>Booking ID:</span>{' '}
          {bookingId?.public_id}
        </p>
      }
      retryPaymentButton={
        <Button
          className={
            'sb-blue-bg gSemiBold br10 fs-20 white txt-center w-full pd-10 mg-top-10 h-fit antd-link-button-override'
          }
          onClick={() => {
            if (!isFreeBooking) {
              setCurrent(USER_BOOKING_STEP_ORDER.indexOf('payment'));
            } else {
              setCurrent(USER_BOOKING_STEP_ORDER.indexOf('summary'));
            }
          }}
        >
          &lt; Back to {isFreeBooking ? 'summary' : 'payment'}
        </Button>
      }
      paymentSuccessfulButton={
        <Button
          className={
            'sb-blue-bg gSemiBold br10 fs-20 white txt-center w-full pd-10 mg-top-10 h-fit antd-link-button-override'
          }
          href={!isInsideWidget ? `/fishery/${fisheryPublicId}` : undefined}
          onClick={() => {
            if (isInsideWidget) {
              sendWidgetMessage({ type: 'widgetCollapse' });
            } else {
              // use href -- do nothing here
            }
          }}
        >
          &lt; Back to profile
        </Button>
      }
    />
  );
}

export default UserBookingFailurePage;
